import {useState, useEffect} from "react";
import moment from "moment";

export function useSessionTimer(selectedEvent, currentTime) {
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        if (!selectedEvent) {
            return;
        }

        const timeDifferenceInMilliseconds = Math.abs(moment(selectedEvent.from).diff(currentTime));
        const sessionDuration = moment.duration(timeDifferenceInMilliseconds);

        setHours(Math.floor(sessionDuration.asHours()));
        setMinutes(sessionDuration.minutes());
        setSeconds(sessionDuration.seconds());
    }, [selectedEvent, currentTime]);

    return {hours, minutes, seconds};
}
